// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* .sc-gIDmry {\n  background-color: #fff;\n} */\n\n/* .ant-tabs {\n  margin-top: 120px;\n} */\n", ""]);
// Exports
module.exports = exports;
